import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const CustomEditor = ({ value, onChange }) => {
  const modules = {
    toolbar: [
      [{ 'font': [] }], 
      [{ 'header': [1, 2, false] }],
      ['bold'],
      // ['link', 'image', ],
      ['link'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      // ['clean'],
    ],
  };

  const formats = [
    'font', 
    'header',
    'bold',
    'link',
    'list', 'bullet',
  ];

  return (
    <ReactQuill
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder="Write text here"
    />
  );
};

export default CustomEditor;
